import Introduction from '../Introduction';
import CoursesForm from '../../../../../../shared/TileCoursesForm';
import ClassesForm from '../../../../../../shared/TileClassesForm';
import useReusePollSteps, { UseReusePollSteps } from './vm';
import { i18nNS } from '../../../../../../../i18n';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '../../../../../../../components/LoadingOverlay';

export enum Steps {
  INTRODUCTION,
  COURSE_SELECTION,
  CLASS_SELECTION,
}

export interface StepsProps extends UseReusePollSteps {
  currentStep: Steps;
}

const ReusePollSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);
  const { goToNextStep } = vmProps;
  const {
    isBlocking,
    selectedCourse,
    handleClickIntroductionNext,
    handleClickCourseSelectionNext,
    handleClickClassSelectionNext,
  } = useReusePollSteps(vmProps);

  switch (currentStep) {
    case Steps.INTRODUCTION:
      return <Introduction onNext={handleClickIntroductionNext} goToNextStep={goToNextStep} />;
    case Steps.COURSE_SELECTION:
      return <CoursesForm onNext={handleClickCourseSelectionNext} />;
    case Steps.CLASS_SELECTION:
      return (
        <>
          {isBlocking && <LoadingOverlay />}
          <ClassesForm
            label={t('copy', { ns: i18nNS.GLOSSARY })}
            selectedCourse={selectedCourse!}
            onNext={handleClickClassSelectionNext}
          />
        </>
      );
    default:
      return null;
  }
};

export default ReusePollSteps;
